import { configure } from 'mobx';
import Fetch from '../fetch/Fetch';
import OrderStore from './OrderStore';
import InteractStore from './InteractStore';
import AddressStore from './AddressStore';
import ReturnMethodStore from './ReturnMethodStore';
import ThemeStore from './ThemeStore';
import ErrorStore from './ErrorStore';
import ConfigStore from './ConfigStore';

configure({ enforceActions: 'observed' });

class RootStore {
  public interact: InteractStore;

  public address: AddressStore;

  public returnMethod: ReturnMethodStore;

  public errors: ErrorStore;

  public order: OrderStore;

  public theme: ThemeStore;

  public config: ConfigStore;

  constructor() {
    const api = new Fetch();
    this.interact = new InteractStore();
    this.address = new AddressStore();
    this.returnMethod = new ReturnMethodStore();
    this.errors = new ErrorStore();
    this.order = new OrderStore(
      api,
      this.address,
      this.returnMethod,
      this.errors
    );
    this.theme = new ThemeStore(api);
    this.config = new ConfigStore(api);
  }
}

export default RootStore;
